import {
  IANA_TO_CODE,
  TIMEZONES,
} from "~/screens/Scheduling/InitialVisit/utils/date-time-utils";

interface IpInfo {
  ip: string;
  country: string;
  region: string;
  city: string;
  timezone: string;
  latitude: number;
  longitude: number;
}

export const getIpInfo = async (): Promise<IpInfo | null> => {
  try {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();

    const ipInfo: IpInfo = {
      ip: data.ip,
      country: data.country_name,
      region: data.region,
      city: data.city,
      timezone: data.timezone,
      latitude: data.latitude,
      longitude: data.longitude,
    };

    return ipInfo;
  } catch (error) {
    console.error("Error getting IP info:", error);
    return null;
  }
};

export const getDefaultTimeZone = (
  ipInfo: IpInfo | null,
  fallbackIana?: string,
): string => {
  const fromIp = ipInfo ? IANA_TO_CODE[ipInfo.timezone] : undefined;
  if (fromIp) return fromIp;

  const fromFallback = fallbackIana ? IANA_TO_CODE[fallbackIana] : undefined;
  return fromFallback ?? TIMEZONES.ET.code;
};
